

<div class="modal-dialog modal-dialog-centered" style=" width: 100% !important; max-width: 100% !important; padding: 0">
    <div class="modal-content">
        <div class="modal-body" style="padding: 0">
            <i class="flaticon-cancel-12 close" (click)="cancel()"></i>
            <div class="statbox box box-shadow mb-4" style="padding: 2rem;">
                <div class="widget-header">
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                            <h4>{{ 'companies.create.companyDescription' | translate}}</h4>
                        </div>
                    </div>
                </div>
                <div class="widget-content widget-content-area">
                    <div class="w-100">
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label>{{ 'companies.create.fullName' | translate}} <span class="text-danger">*</span></label>
                                <input [(ngModel)]="newCompany.Name" name="name" type="text" class="form-control" [placeholder]="'companies.create.fullName' | translate">
                                <span class="form-text text-muted">{{ 'companies.create.enterFullName' | translate}}</span>
                            </div>

                            <div class="col-lg-6">
                                <label>{{ 'companies.create.direction' | translate}}</label>
                                <input [(ngModel)]="newCompany.Address" name="address" type="text" maxlength="256" class="form-control" [placeholder]="'companies.create.direction' | translate">
                                <span class="form-text text-muted">{{ 'companies.create.enterLocation' | translate}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label>{{ 'companies.create.webUrl' | translate}}</label>
                                <input [(ngModel)]="newCompany.WebAddress" name="webAddress" type="text" class="form-control" [placeholder]="'companies.create.webUrl' | translate">
                                <span class="form-text text-muted">{{ 'companies.create.enterWebUrl' | translate}}</span>

                                <label style="margin-top: 20px;">{{ 'companies.create.phone' | translate}}</label>
                                <div class="input-group">
                                    <input [(ngModel)]="newCompany.Phone" name="phone" type="text" class="form-control" [placeholder]="'companies.create.phone' | translate">
                                </div>
                                <span class="form-text text-muted">{{ 'companies.create.enterPhone' | translate}}</span>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group mb-1">
                                    <label for="exampleTextarea">{{ 'companies.create.description' | translate}} </label>
                                    <textarea [(ngModel)]="newCompany.Description" name="description" class="form-control" id="exampleTextarea" rows="6"></textarea>
                                </div>
                                <span class="form-text text-muted">{{ 'companies.create.enterDescription' | translate}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label >{{ 'companies.create.email' | translate}}</label>
                                <div class="input-group">
                                    <input [(ngModel)]="newCompany.Email" name="email" type="text" class="form-control" [placeholder]="'companies.create.email' | translate">
                                </div>
                                <span class="form-text text-muted">{{ 'companies.create.enterEmail' | translate}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-4">
                                        <div class="form-group row">
                                            <div class="col-lg-12 col-sm-12">
                                                <div id="dropzone">
                                                    <label for="exampleTextarea">Logo</label>
                                                        <div class="dz-message needsclick">
                                                        <input type="file" (change)="onFileSelected($event)" accept="image/*" class="dz-message needsclick">
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <h5>{{ 'companies.create.tenantConection' | translate}}</h5>
                        </div>
                        <div class="form-group row">
                            <span>{{ 'companies.create.tenantConectionSub' | translate}}</span>                                                  
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label>{{ 'companies.create.appId' | translate}}</label>
                                <input [(ngModel)]="newCompany.ApplicationId" name="applicationId" type="text" class="form-control" [placeholder]="'companies.create.appId' | translate">
                                <span class="form-text text-muted">{{ 'companies.create.enterAppId' | translate}}</span>

                                <label style="margin-top: 20px">{{ 'companies.create.webDomain' | translate}}</label>
                                <input [(ngModel)]="newCompany.WebDomain" name="webDomain" type="text" class="form-control" [placeholder]="'companies.create.webDomain' | translate">
                                <span class="form-text text-muted">{{ 'companies.create.enterWebDomain' | translate}}</span>
                            </div>
                            <div class="col-lg-6">
                                <div id="dropzone">
                                    <label for="exampleTextarea">{{ 'companies.create.certificate' | translate}}</label>
                                        <div class="dz-message needsclick" >
                                        <input type="file" (change)="onFileSelectedCertificate($event)" accept="image/*" class="dz-message needsclick" >
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label>{{ 'companies.create.certificateId' | translate}}</label>
                                <div class="input-group">
                                    <input [(ngModel)]="newCompany.Certificate" name="name" type="text" class="form-control" [placeholder]="'companies.create.certificateId' | translate">
                                </div>
                                <span class="form-text text-muted">{{ 'companies.create.enterCertificateId' | translate}}</span>
                            </div>
                            <div class="col-lg-6">
                                <label>{{ 'companies.create.password' | translate}}</label>
                                <div class="input-group">
                                    <input [(ngModel)]="newCompany.CertificatePassword" name="password" type="text" class="form-control" [placeholder]="'companies.create.password' | translate">
                                </div>
                                <span class="form-text text-muted">{{ 'companies.create.enterPassword' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <div class="modal-footer">
            <button class="btn btn-sm btn-outline" (click)="cancel()">{{ 'cancel' | translate }}</button>
            <button class="btn btn-sm btn-primary" type="submit" (click)="save()">{{ 'submit' | translate }}</button>
        </div>
    </div>
</div>
